import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { MsalService } from '@azure/msal-angular';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
    CheckUserEmailRequestDTO,
    CheckUserEmailResponseDTO,
    ReadAccessPermissionsRequestDTO,
    ReadAccessPermissionsResponseDTO,
    ReadMetaRequestDTO,
    ReadMetaResponseDTO,
} from '../dtos';
import { BaseService } from './base.service';
import { GlobalsService } from './globals.service';
import { isAssigned, replaceEmailExt } from '../utils';

@Injectable()
export class MetaService extends BaseService {
    private _metaUrl: string;

    constructor(
        private readonly _http: HttpClient,
        globalsSrv: GlobalsService,
        authSrv: MsalService,
    ) {
        super(globalsSrv, authSrv);

        this._metaUrl = `${this.apiUrl}/Meta`;
    }

    readMeta(request: ReadMetaRequestDTO): Observable<ReadMetaResponseDTO> {
        request.userEmail = replaceEmailExt(request.userEmail);

        const options = {
            params: this.getHttpParams(request),
            headers: this.getHttpHeaders(),
        };

        return this._http.get<ReadMetaResponseDTO>(this._metaUrl, options).pipe(catchError(this.onHttpError));
    }

    readPermisions(): Observable<string> {
        const request: ReadAccessPermissionsRequestDTO = {};
        const options = {
            params: this.getHttpParams(request),
            headers: this.getHttpHeaders(),
        };

        return this._http.get<ReadAccessPermissionsResponseDTO>(`${this._metaUrl}/permissions`, options).pipe(
            map((response) => {
                this.globalsSrv.setPermissions(response.permissions);

                if (!isAssigned(this.globalsSrv.currentUser?.userId)) {
                    const userId = Number(response.userId);
                    if (!Number.isNaN(userId) && userId > 0) {
                        this.globalsSrv.currentUser!.userId = userId;
                    }
                }

                return '';
            }),
            catchError(this.onHttpError),
        );
    }

    checkUserEmail(request: CheckUserEmailRequestDTO): Observable<CheckUserEmailResponseDTO> {
        request.userEmail = replaceEmailExt(request.userEmail);

        const options = {
            params: this.getHttpParams(),
            headers: this.getHttpHeaders(),
        };

        return this._http
            .post<CheckUserEmailResponseDTO>(`${this._metaUrl}/check-user-email`, this.fillRequestData(request), options)
            .pipe(catchError(this.onHttpError));
    }
}
